import moment from 'moment';
import { formatDateOrDateTime } from '../../../../src/utils';

const Event = (props) => {
  const startDate = props.StartDate ? formatDateOrDateTime(props.StartDate) : moment().format();
  const endDate = props.EndDate ? formatDateOrDateTime(props.EndDate) : moment().format();

  return `{
      "@type": "Event",
      "name": "${props.Name ? props.Name : props.Title}",
      "startDate": "${startDate}",
      "endDate": "${endDate}",
      "location": {
        "@type": "Place",
        "name": "${props.Address.venue ? props.Address.venue : ''}",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "${props.Address.line1 ? props.Address.line1 : ''}",
          "addressRegion": "${props.Address.city}",
          "postalCode": "${props.Address.postcode}",
          "addressCountry": "UK"
        }
      },
      "description": "${props.Description}"
    }`;
};

export default Event;
